import {
    IStatusType,
} from '../types';

export function formatDescription(type: IStatusType): string {
    switch (type) {
        case 'SUCCESS': {
            return 'Your payment has been confirmed.';
        }
        case 'FAILED': {
            return 'We could not confirm this transaction.';
        }
        case 'NOT_FOUND': {
            return 'We can not find your payment.';
        }
    }
}
